import type { USER_SNS_TYPE } from '@/features/Auth/type';
import { MCO_DOMAIN } from '@/libs/constant';
import { T } from '@/libs/translation';
import { resizeS3Image } from '@/libs/util/resizeS3Image';
import { html, View } from 'rune-ts';

export interface EmailCertificationTemplateType {
  code: string;
}

class MarppleShopEmailCertificationForSignupTemplate extends View<EmailCertificationTemplateType> {
  override template() {
    return html` <div>
      <table cellspacing="0" cellpadding="0" border="0" width="100%">
        <tbody>
          <tr>
            <td>
              <div style="height:48px;"></div>
            </td>
          </tr>
          <tr>
            <td height="200" style="text-align: center">
              <div style="text-align: center">
                <img
                  src="https://s3.marpple.co/files/u_3040850/2024/8/original/6287015da1f15aede3cb288467236d1bdff01aa71.png"
                  alt="MARPPLESHOP"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td height="24"></td>
          </tr>
          <tr>
            <td>
              <div style="text-align: center; font-size: 26px; font-weight: 700; line-height: 130%; color: #000;">
                ${html.preventEscape(T('email.template.email_certification.title'))}
              </div>
            </td>
          </tr>
          <tr>
            <td height="24">
              <div style="height: 24px"></div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 24px"></div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                style="height: 72px; padding: 0 24px;text-align: center; font-size: 16px;font-style: normal;font-weight: 500;line-height: 150%; word-break: keep-all;"
              >
                ${html.preventEscape(T('email.template.email_certification.description.signup_marppleshop'))}
              </div>
            </td>
          </tr>
          <tr>
            <td height="24">
              <div style="height: 24px"></div>
            </td>
          </tr>
          <tr>
            <td height="48">
              <div
                style="padding: 0 24px;text-align: center;font-size: 16px;font-style: normal;font-weight: 500;line-height: 150%; word-break: keep-all;"
              >
                ${html.preventEscape(T('email.template.email_certification.description.signup_complete'))}
              </div>
            </td>
          </tr>
          <tr>
            <td height="48">
              <div style="height: 48px"></div>
            </td>
          </tr>
          <tr>
            <td height="24">
              <div style="text-align: center; font-size: 16px;font-style: normal;font-weight: 700;line-height: 150%;">
                ${html.preventEscape(T('email.template.email_certification.certification_code'))}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 16px"></div>
            </td>
          </tr>
          <tr>
            <td height="60">
              <table cellspacing="0" cellpadding="0" border="0" style="margin:0 auto;">
                <tbody>
                  <tr>
                    <td width="320">
                      <div style="border-radius:12px;background-color:#EBF3FE;">
                        <table cellspacing="0" cellpadding="0" border="0" width="100%">
                          <tbody>
                            <tr>
                              <td height="16"></td>
                            </tr>
                            <tr>
                              <td height="28" align="center">
                                <span
                                  style="text-align: center;font-size: 20px;font-style: normal;font-weight: 700;line-height: 28px;letter-spacing: 4px;color:#1C75FF"
                                  >${this.data.code}</span
                                >
                              </td>
                            </tr>
                            <tr>
                              <td height="16"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 16px"></div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                style="text-align: center;font-size: 14px;font-style: normal;font-weight: 500;line-height: 22px;letter-spacing: -0.2px;color: #a2a2a2;"
              >
                ${html.preventEscape(T('email.template.email_certification.description.certification_code'))}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 16px"></div>
            </td>
          </tr>
          <tr>
            <td height="44">
              <div
                style="padding: 0 24px;text-align: center;font-size: 14px;font-style: normal;font-weight: 500;line-height: 22px; word-break: keep-all;"
              >
                ${html.preventEscape(T('email.template.email_certification.description.warning'))}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>`;
  }
}

class MarppleEmailCertificationForSignupTemplate extends View<EmailCertificationTemplateType> {
  override template() {
    return html` <div>
      <table cellspacing="0" cellpadding="0" border="0" width="100%">
        <tbody>
          <tr>
            <td>
              <div style="height:48px;"></div>
            </td>
          </tr>
          <tr>
            <td height="180" style="text-align: center">
              <div style="text-align: center">
                <img
                  src="https://s3.marpple.co/files/u_3040850/2024/8/original/ef69c3d38ea9c4570cce83688328bcb40aaaddfb1.png"
                  alt="MARPPLE"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td height="24"></td>
          </tr>
          <tr>
            <td>
              <div
                style="text-align: center; font-size: 28px;font-style: normal;font-weight: 700;line-height: 130%; color: #000;"
              >
                ${html.preventEscape(T('email.template.email_certification.title'))}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 24px"></div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                style="height: 72px; padding: 0 24px;text-align: center; font-size: 16px;font-style: normal;font-weight: 500;line-height: 150%; word-break: keep-all;"
              >
                ${html.preventEscape(T('email.template.email_certification.description.signup'))}
              </div>
            </td>
          </tr>
          <tr>
            <td height="24">
              <div style="height: 24px"></div>
            </td>
          </tr>
          <tr>
            <td height="48">
              <div
                style="padding: 0 24px;text-align: center;font-size: 16px;font-style: normal;font-weight: 500;line-height: 150%; word-break: keep-all;"
              >
                ${html.preventEscape(T('email.template.email_certification.description.signup_complete'))}
              </div>
            </td>
          </tr>
          <tr>
            <td height="48">
              <div style="height: 48px"></div>
            </td>
          </tr>
          <tr>
            <td height="24">
              <div style="text-align: center; font-size: 16px;font-style: normal;font-weight: 700;line-height: 150%;">
                ${html.preventEscape(T('email.template.email_certification.certification_code'))}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 24px"></div>
            </td>
          </tr>
          <tr>
            <td height="82">
              <table cellspacing="0" cellpadding="0" border="0" style="margin:0 auto;">
                <tbody>
                  <tr>
                    <td width="320">
                      <div style="border-radius:12px;background-color:#F6F6F6;">
                        <table cellspacing="0" cellpadding="0" border="0" width="100%">
                          <tbody>
                            <tr>
                              <td height="24"></td>
                            </tr>
                            <tr>
                              <td height="34" align="center">
                                <span
                                  style="text-align: center;font-size: 26px;font-style: normal;font-weight: 500;line-height: 130%;letter-spacing: 8px;color:#000"
                                  >${this.data.code}</span
                                >
                              </td>
                            </tr>
                            <tr>
                              <td height="24"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 16px"></div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                style="text-align: center;font-size: 14px;font-style: normal;font-weight: 500;line-height: 140%;color: #858585;"
              >
                ${html.preventEscape(T('email.template.email_certification.description.certification_code'))}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 16px"></div>
            </td>
          </tr>
          <tr>
            <td height="44">
              <div
                style="padding: 0 24px;text-align: center;font-size: 14px;font-style: normal;font-weight: 500;line-height: 22px; word-break: keep-all;"
              >
                ${html.preventEscape(T('email.template.email_certification.description.warning'))}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>`;
  }
}

class CietyEmailCertificationForSignupTemplate extends View<EmailCertificationTemplateType> {
  override template() {
    return html` <div>
      <table cellspacing="0" cellpadding="0" border="0" width="100%">
        <tbody>
          <tr>
            <td>
              <div style="height:48px;"></div>
            </td>
          </tr>
          <tr>
            <td height="200" style="text-align: center">
              <div style="text-align: center">
                <img
                  src="${resizeS3Image({
                    url: 'https://s3.marpple.co/files/u_2283830/2025/3/original/4bf4872178f89917acd38b9660ba67a72ef5add82.png',
                    quality: 100,
                    height: 180,
                    width: 240,
                  })}"
                  alt="CIETY"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td height="24"></td>
          </tr>
          <tr>
            <td>
              <div style="text-align: center; font-size: 26px; font-weight: 700; line-height: 130%; color: #FBFBFB;">
                ${html.preventEscape(T('email.template.email_certification.title'))}
              </div>
            </td>
          </tr>
          <tr>
            <td height="24">
              <div style="height: 24px"></div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                style="padding: 0 24px;text-align: center; font-size: 16px;font-style: normal;font-weight: 500;line-height: 150%; word-break: keep-all; color: #FBFBFB;"
              >
                ${html.preventEscape(T('email.template.email_certification.description.signup_ciety'))}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 24px"></div>
            </td>
          </tr>
          <tr>
            <td height="48">
              <div
                style="padding: 0 24px;text-align: center;font-size: 16px;font-style: normal;font-weight: 500;line-height: 150%; word-break: keep-all; color: #FBFBFB;"
              >
                ${html.preventEscape(T('email.template.email_certification.description.ciety_guide'))}
              </div>
            </td>
          </tr>
          <tr>
            <td height="48">
              <div style="height: 48px"></div>
            </td>
          </tr>
          <tr>
            <td height="24">
              <div
                style="text-align: center; font-size: 16px;font-style: normal;font-weight: 700;line-height: 150%; color: #FBFBFB;"
              >
                ${html.preventEscape(T('email.template.email_certification.certification_code'))}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 16px"></div>
            </td>
          </tr>
          <tr>
            <td height="60">
              <table cellspacing="0" cellpadding="0" border="0" style="margin:0 auto;">
                <tbody>
                  <tr>
                    <td width="320">
                      <div style="border-radius:12px;background-color:#1C1C24;">
                        <table cellspacing="0" cellpadding="0" border="0" width="100%">
                          <tbody>
                            <tr>
                              <td height="16"></td>
                            </tr>
                            <tr>
                              <td height="28" align="center">
                                <span
                                  style="text-align: center;font-size: 20px;font-style: normal;font-weight: 700;line-height: 28px;letter-spacing: 4px;color:#B2FF00"
                                  >${this.data.code}</span
                                >
                              </td>
                            </tr>
                            <tr>
                              <td height="16"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 16px"></div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                style="text-align: center;font-size: 14px;font-style: normal;font-weight: 500;line-height: 22px;letter-spacing: -0.2px;color: #a2a2a2;"
              >
                ${html.preventEscape(T('email.template.email_certification.description.certification_code'))}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 16px"></div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                style="text-align: center;font-size: 14px;font-style: normal;font-weight: 500;line-height: 22px;letter-spacing: -0.2px;color: #FBFBFB;"
              >
                ${html.preventEscape(T('email.template.email_certification.description.warning'))}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>`;
  }
}

class MarppleShopEmailCertificationTemplate extends View<EmailCertificationTemplateType> {
  override template() {
    return html` <div>
      <table cellspacing="0" cellpadding="0" border="0" width="100%">
        <tbody>
          <tr>
            <td>
              <div style="height:48px;"></div>
            </td>
          </tr>
          <tr>
            <td height="200" style="text-align: center">
              <div style="text-align: center">
                <img
                  src="https://s3.marpple.co/files/u_3040850/2024/8/original/6287015da1f15aede3cb288467236d1bdff01aa71.png"
                  alt="MARPPLESHOP"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td height="24"></td>
          </tr>
          <tr>
            <td>
              <div style="text-align: center; font-size: 26px; font-weight: 700; line-height: 130%; color: #000;">
                ${html.preventEscape(T('email.template.email_certification.title'))}
              </div>
            </td>
          </tr>
          <tr>
            <td height="24">
              <div style="height: 24px"></div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                style="padding: 0 24px;text-align: center; font-size: 16px;font-style: normal;font-weight: 500;line-height: 150%; word-break: keep-all;"
              >
                ${html.preventEscape(T('email.template.email_certification.description.marppleshop'))}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 24px"></div>
            </td>
          </tr>
          <tr>
            <td height="48">
              <div
                style="padding: 0 24px;text-align: center;font-size: 16px;font-style: normal;font-weight: 500;line-height: 150%; word-break: keep-all;"
              >
                ${html.preventEscape(
                  T('email.template.email_certification.description.contact', {
                    tel: '1566-5496',
                    email: 'cs@marppleshop.com',
                  }),
                )}
              </div>
            </td>
          </tr>
          <tr>
            <td height="48">
              <div style="height: 48px"></div>
            </td>
          </tr>
          <tr>
            <td height="24">
              <div style="text-align: center; font-size: 16px;font-style: normal;font-weight: 700;line-height: 150%;">
                ${html.preventEscape(T('email.template.email_certification.certification_code'))}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 16px"></div>
            </td>
          </tr>
          <tr>
            <td height="60">
              <table cellspacing="0" cellpadding="0" border="0" style="margin:0 auto;">
                <tbody>
                  <tr>
                    <td width="320">
                      <div style="border-radius:12px;background-color:#EBF3FE;">
                        <table cellspacing="0" cellpadding="0" border="0" width="100%">
                          <tbody>
                            <tr>
                              <td height="16"></td>
                            </tr>
                            <tr>
                              <td height="28" align="center">
                                <span
                                  style="text-align: center;font-size: 20px;font-style: normal;font-weight: 700;line-height: 28px;letter-spacing: 4px;color:#1C75FF"
                                  >${this.data.code}</span
                                >
                              </td>
                            </tr>
                            <tr>
                              <td height="16"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 16px"></div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                style="text-align: center;font-size: 14px;font-style: normal;font-weight: 500;line-height: 22px;letter-spacing: -0.2px;color: #a2a2a2;"
              >
                ${html.preventEscape(T('email.template.email_certification.description.certification_code'))}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 16px"></div>
            </td>
          </tr>
          <tr>
            <td height="44">
              <div
                style="padding: 0 24px;text-align: center;font-size: 14px;font-style: normal;font-weight: 500;line-height: 22px; word-break: keep-all;"
              >
                ${html.preventEscape(T('email.template.email_certification.description.warning'))}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>`;
  }
}

class MarppleEmailCertificationTemplate extends View<EmailCertificationTemplateType> {
  override template() {
    return html` <div>
      <table cellspacing="0" cellpadding="0" border="0" width="100%">
        <tbody>
          <tr>
            <td>
              <div style="height:48px;"></div>
            </td>
          </tr>
          <tr>
            <td height="180" style="text-align: center">
              <div style="text-align: center">
                <img
                  src="https://s3.marpple.co/files/u_3040850/2024/8/original/ef69c3d38ea9c4570cce83688328bcb40aaaddfb1.png"
                  alt="MARPPLE"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td height="24"></td>
          </tr>
          <tr>
            <td>
              <div
                style="text-align: center; font-size: 28px;font-style: normal;font-weight: 700;line-height: 130%; color: #000;"
              >
                ${html.preventEscape(T('email.template.email_certification.title'))}
              </div>
            </td>
          </tr>
          <tr>
            <td height="24">
              <div style="height: 24px"></div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                style="padding: 0 24px;text-align: center; font-size: 16px;font-style: normal;font-weight: 500;line-height: 150%; word-break: keep-all;"
              >
                ${html.preventEscape(T('email.template.email_certification.description.marpple'))}
              </div>
            </td>
          </tr>
          <tr>
            <td height="24">
              <div style="height: 24px"></div>
            </td>
          </tr>
          <tr>
            <td height="48">
              <div
                style="padding: 0 24px;text-align: center;font-size: 16px;font-style: normal;font-weight: 500;line-height: 150%; word-break: keep-all;"
              >
                ${html.preventEscape(
                  T('email.template.email_certification.description.contact', {
                    tel: '1566-9437',
                    email: 'help@marpple.com',
                  }),
                )}
              </div>
            </td>
          </tr>
          <tr>
            <td height="48">
              <div style="height: 48px"></div>
            </td>
          </tr>
          <tr>
            <td height="24">
              <div style="text-align: center; font-size: 16px;font-style: normal;font-weight: 700;line-height: 150%;">
                ${html.preventEscape(T('email.template.email_certification.certification_code'))}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 24px"></div>
            </td>
          </tr>
          <tr>
            <td height="82">
              <table cellspacing="0" cellpadding="0" border="0" style="margin:0 auto;">
                <tbody>
                  <tr>
                    <td width="320">
                      <div style="border-radius:12px;background-color:#F6F6F6;">
                        <table cellspacing="0" cellpadding="0" border="0" width="100%">
                          <tbody>
                            <tr>
                              <td height="24"></td>
                            </tr>
                            <tr>
                              <td height="34" align="center">
                                <span
                                  style="text-align: center;font-size: 26px;font-style: normal;font-weight: 500;line-height: 130%;letter-spacing: 8px;color:#000"
                                  >${this.data.code}</span
                                >
                              </td>
                            </tr>
                            <tr>
                              <td height="24"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 16px"></div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                style="text-align: center;font-size: 14px;font-style: normal;font-weight: 500;line-height: 140%;color: #858585;"
              >
                ${html.preventEscape(T('email.template.email_certification.description.certification_code'))}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 16px"></div>
            </td>
          </tr>
          <tr>
            <td height="44">
              <div
                style="padding: 0 24px;text-align: center;font-size: 14px;font-style: normal;font-weight: 500;line-height: 22px; word-break: keep-all;"
              >
                ${html.preventEscape(T('email.template.email_certification.description.warning'))}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>`;
  }
}

class CietyEmailCertificationTemplate extends View<EmailCertificationTemplateType> {
  override template() {
    return html` <div>
      <table cellspacing="0" cellpadding="0" border="0" width="100%">
        <tbody>
          <tr>
            <td>
              <div style="height:48px;"></div>
            </td>
          </tr>
          <tr>
            <td height="200" style="text-align: center">
              <div style="text-align: center">
                <img
                  src="${resizeS3Image({
                    url: 'https://s3.marpple.co/files/u_2283830/2025/3/original/4bf4872178f89917acd38b9660ba67a72ef5add82.png',
                    quality: 100,
                    height: 180,
                    width: 240,
                  })}"
                  alt="CIETY"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td height="24"></td>
          </tr>
          <tr>
            <td>
              <div style="text-align: center; font-size: 26px; font-weight: 700; line-height: 130%; color: #FBFBFB;">
                ${html.preventEscape(T('email.template.email_certification.title'))}
              </div>
            </td>
          </tr>
          <tr>
            <td height="24">
              <div style="height: 24px"></div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                style="padding: 0 24px;text-align: center; font-size: 16px;font-style: normal;font-weight: 500;line-height: 150%; word-break: keep-all; color: #FBFBFB;"
              >
                ${html.preventEscape(T('email.template.email_certification.description.ciety'))}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 24px"></div>
            </td>
          </tr>
          <tr>
            <td height="48">
              <div
                style="padding: 0 24px;text-align: center;font-size: 16px;font-style: normal;font-weight: 500;line-height: 150%; word-break: keep-all; color: #FBFBFB;"
              >
                ${html.preventEscape(
                  T('email.template.email_certification.description.contact_ciety', {
                    email: 'contact@ciety.io',
                  }),
                )}
              </div>
            </td>
          </tr>
          <tr>
            <td height="48">
              <div style="height: 48px"></div>
            </td>
          </tr>
          <tr>
            <td height="24">
              <div
                style="text-align: center; font-size: 16px;font-style: normal;font-weight: 700;line-height: 150%; color: #FBFBFB;"
              >
                ${html.preventEscape(T('email.template.email_certification.certification_code'))}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 16px"></div>
            </td>
          </tr>
          <tr>
            <td height="60">
              <table cellspacing="0" cellpadding="0" border="0" style="margin:0 auto;">
                <tbody>
                  <tr>
                    <td width="320">
                      <div style="border-radius:12px;background-color:#1C1C24;">
                        <table cellspacing="0" cellpadding="0" border="0" width="100%">
                          <tbody>
                            <tr>
                              <td height="16"></td>
                            </tr>
                            <tr>
                              <td height="28" align="center">
                                <span
                                  style="text-align: center;font-size: 20px;font-style: normal;font-weight: 700;line-height: 28px;letter-spacing: 4px;color:#B2FF00"
                                  >${this.data.code}</span
                                >
                              </td>
                            </tr>
                            <tr>
                              <td height="16"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 16px"></div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                style="text-align: center;font-size: 14px;font-style: normal;font-weight: 500;line-height: 22px;letter-spacing: -0.2px;color: #a2a2a2;"
              >
                ${html.preventEscape(T('email.template.email_certification.description.certification_code'))}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>`;
  }
}

export interface SignupEmailTemplateType {
  name: string;
  email: string;
  sns?: USER_SNS_TYPE;
}

const SNS_LOGO = {
  KAKAO: 'https://s3.marpple.co/files/u_3040850/2024/8/original/78a807dde260e34669d3fea5b7e3b354979533c71.png',
  GOOGLE: 'https://s3.marpple.co/files/u_3040850/2024/8/original/bf86d4d9dfcbc2538bc8e49bf5fac35f785642131.png',
  APPLE: 'https://s3.marpple.co/files/u_3040850/2024/8/original/367396c01f30906d9638c1c777ae1a3d6215162f1.png',
  FACEBOOK: 'https://s3.marpple.co/files/u_3040850/2024/8/original/56daa4a9987ab8cb9576c84decac6d7b55e9f8a51.png',
  NAVER: 'https://s3.marpple.co/files/u_3040850/2024/8/original/53b416616cf07b83135d61d9944e06a2fbae97361.png',
};

class MarppleShopSignupEmailTemplate extends View<SignupEmailTemplateType> {
  override template() {
    return html` <div>
      <table cellspacing="0" cellpadding="0" border="0" width="100%">
        <tbody>
          <tr>
            <td>
              <div style="height:48px;"></div>
            </td>
          </tr>
          <tr>
            <td height="180" style="text-align: center">
              <div style="text-align: center">
                <img
                  src="https://s3.marpple.co/files/u_3040850/2024/8/original/e9e4ddaafc4924fc1d067398a0d38de681a5b16f1.png"
                  alt="MARPPLESHOP"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td height="24"></td>
          </tr>
          <tr>
            <td>
              <div
                style="text-align: center; font-size: 28px;font-style: normal;font-weight: 700;line-height: 130%; color: #000;"
              >
                ${html.preventEscape(T('email.template.signup.title.marppleshop'))}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 24px"></div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                style="height: 72px; padding: 0 24px;text-align: center; font-size: 16px;font-style: normal;font-weight: 500;line-height: 150%; word-break: keep-all;"
              >
                ${html.preventEscape(T('email.template.signup.description.marppleshop', { name: this.data.name }))}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 48px"></div>
            </td>
          </tr>
          <tr>
            <td style="padding: 0 24px">
              <table cellspacing="0" cellpadding="0" border="0" style="border-top: 1px solid #1C75FF" width="100%">
                <tbody>
                  <tr>
                    <td height="16"></td>
                  </tr>
                  <tr>
                    <td>
                      <div
                        style="font-size: 20px;font-style: normal;font-weight: 700;line-height: 100%; color:#1C75FF;"
                      >
                        ${T('email.template.signup.info')}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td height="16"></td>
                  </tr>
                  <tr>
                    <td style="font-size: 16px;font-style: normal;font-weight: 500;line-height: 150%;">
                      ${T('email.template.signup.id')}
                    </td>
                    <td style="color:#1C75FF;text-align: right;">
                      <span
                        style="margin-right: 4px;font-size: 16px;font-style: normal;font-weight: 500;line-height: 150%;"
                        >${this.data.email}</span
                      >
                      ${this.data.sns
                        ? html`<img
                            src="${SNS_LOGO[this.data.sns]}"
                            style="width: 20px; height: 20px; vertical-align: middle;"
                          />`
                        : ''}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 48px"></div>
            </td>
          </tr>
          <tr>
            <td height="56">
              <table cellspacing="0" cellpadding="0" border="0" style="margin:0 auto;">
                <tbody>
                  <tr>
                    <td width="268">
                      <div style="border-radius:12px;background-color:#1C75FF;">
                        <table cellspacing="0" cellpadding="0" border="0" width="100%">
                          <tbody>
                            <tr>
                              <td align="center">
                                <a
                                  href="${MCO_DOMAIN.MarppleShop}"
                                  target="_blank"
                                  style="display: block; padding: 16px 24px; text-align: center; background-color: #1C75FF; color: #fff; margin: 0 auto; border-radius: 12px; text-decoration: none;font-size: 16px;font-style: normal; font-weight: 700;line-height: 24px;letter-spacing: -0.2px;"
                                  >${T('email.template.signup.go_marppleshop')}</a
                                >
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>`;
  }
}

class MarppleSignupEmailTemplate extends View<SignupEmailTemplateType> {
  override template() {
    return html` <div>
      <table cellspacing="0" cellpadding="0" border="0" width="100%">
        <tbody>
          <tr>
            <td>
              <div style="height:48px;"></div>
            </td>
          </tr>
          <tr>
            <td height="180" style="text-align: center">
              <div style="text-align: center">
                <img
                  src="https://s3.marpple.co/files/u_3040850/2024/8/original/ef69c3d38ea9c4570cce83688328bcb40aaaddfb1.png"
                  alt="MARPPLE"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td height="24"></td>
          </tr>
          <tr>
            <td>
              <div
                style="text-align: center; font-size: 28px;font-style: normal;font-weight: 700;line-height: 130%; color: #000;"
              >
                ${html.preventEscape(T('email.template.signup.title.marpple'))}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 24px"></div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                style="height: 72px; padding: 0 24px;text-align: center; font-size: 16px;font-style: normal;font-weight: 500;line-height: 150%; word-break: keep-all;"
              >
                ${html.preventEscape(T('email.template.signup.description.marpple', { name: this.data.name }))}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 48px"></div>
            </td>
          </tr>
          <tr>
            <td style="padding: 0 24px">
              <table cellspacing="0" cellpadding="0" border="0" style="border-top: 1px solid #000" width="100%">
                <tbody>
                  <tr>
                    <td height="16"></td>
                  </tr>
                  <tr>
                    <td>
                      <div style="font-size: 20px;font-style: normal;font-weight: 700;line-height: 100%;">
                        ${T('email.template.signup.info')}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td height="16"></td>
                  </tr>
                  <tr>
                    <td style="font-size: 16px;font-style: normal;font-weight: 500;line-height: 150%;">
                      ${T('email.template.signup.id')}
                    </td>
                    <td style="color:#FF6B00;text-align: right;">
                      <span
                        style="margin-right: 4px;font-size: 16px;font-style: normal;font-weight: 500;line-height: 150%;"
                        >${this.data.email}</span
                      >
                      ${this.data.sns
                        ? html`<img
                            src="${SNS_LOGO[this.data.sns]}"
                            style="width: 20px; height: 20px; vertical-align: middle;"
                          />`
                        : ''}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 48px"></div>
            </td>
          </tr>
          <tr>
            <td
              style="height: 24px; text-align: center;font-size: 16px;font-style: normal;font-weight: 500;line-height: 150%;"
            >
              ${T('email.template.signup.thank_you')}
            </td>
          </tr>
        </tbody>
      </table>
    </div>`;
  }
}

class CietySignupEmailTemplate extends View<SignupEmailTemplateType> {
  override template() {
    return html` <div>
      <table cellspacing="0" cellpadding="0" border="0" width="100%">
        <tbody>
          <tr>
            <td>
              <div style="height:48px;"></div>
            </td>
          </tr>
          <tr>
            <td height="180" style="text-align: center">
              <div style="text-align: center">
                <img
                  src="${resizeS3Image({
                    url: 'https://s3.marpple.co/files/u_2283830/2025/3/original/1caff292d94383ec950d8e248a1a71244e660f341.png',
                    quality: 100,
                    height: 180,
                    width: 240,
                  })}"
                  alt="CIETY"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td height="24"></td>
          </tr>
          <tr>
            <td>
              <div
                style="text-align: center; font-size: 28px;font-style: normal;font-weight: 700;line-height: 130%; color: #FBFBFB;"
              >
                ${html.preventEscape(T('email.template.signup.title.ciety'))}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 24px"></div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                style="height: 72px; padding: 0 24px;text-align: center; font-size: 16px;font-style: normal;font-weight: 500;line-height: 150%; word-break: keep-all; color: #FBFBFB;"
              >
                ${html.preventEscape(T('email.template.signup.description.ciety', { name: this.data.name }))}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 48px"></div>
            </td>
          </tr>
          <tr>
            <td style="padding: 0 24px">
              <table cellspacing="0" cellpadding="0" border="0" style="border-top: 1px solid #B2FF00" width="100%">
                <tbody>
                  <tr>
                    <td height="16"></td>
                  </tr>
                  <tr>
                    <td>
                      <div
                        style="font-size: 20px;font-style: normal;font-weight: 700;line-height: 100%; color:#B2FF00;"
                      >
                        ${T('email.template.signup.info')}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td height="16"></td>
                  </tr>
                  <tr>
                    <td style="font-size: 16px;font-style: normal;font-weight: 500;line-height: 150%; color: #FBFBFB;">
                      ${T('email.template.signup.id')}
                    </td>
                    <td style="color:#B2FF00; text-align: right;">
                      <span
                        style="margin-right: 4px;font-size: 16px;font-style: normal;font-weight: 500;line-height: 150%;"
                        >${this.data.email}</span
                      >
                      ${this.data.sns
                        ? html`<img
                            src="${SNS_LOGO[this.data.sns]}"
                            style="width: 20px; height: 20px; vertical-align: middle;"
                          />`
                        : ''}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 48px"></div>
            </td>
          </tr>
          <tr>
            <td height="56">
              <table cellspacing="0" cellpadding="0" border="0" style="margin:0 auto;">
                <tbody>
                  <tr>
                    <td width="268">
                      <div style="border-radius:999px;background-color:#B2FF00;">
                        <table cellspacing="0" cellpadding="0" border="0" width="100%">
                          <tbody>
                            <tr>
                              <td align="center">
                                <a
                                  href="${MCO_DOMAIN.Ciety}"
                                  target="_blank"
                                  style="display: block; padding: 16px 24px; text-align: center; background-color: #B2FF00; color: #1C1C24; margin: 0 auto; border-radius: 999px; text-decoration: none;font-size: 16px;font-style: normal; font-weight: 500;line-height: 150%;"
                                  >${T('email.template.signup.go_ciety')}</a
                                >
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>`;
  }
}

export interface EmailLayoutType {
  template: View;
}

export class MarppleEmailLayout extends View<EmailLayoutType> {
  override template() {
    return html`<table cellspacing="0" cellpadding="0" border="0" width="100%" bgcolor="#f6f6f6">
      <tr>
        <td height="40"></td>
      </tr>
      <tr>
        <td>
          <div style="max-width: 600px; margin:0 auto;">
            <div>
              <table cellspacing="0" cellpadding="0" width="100%" bgcolor="#ffffff">
                <tbody>
                  <tr>
                    <td height="48"></td>
                  </tr>
                  <tr>
                    <td height="24" style="text-align: center">
                      <a style="height: 24px" href="${MCO_DOMAIN.Marpple}" target="_blank">
                        <img
                          style="height: 24px"
                          src="https://s3.marpple.co/files/u_2283830/2024/9/original/c42fb0e88155b78fcac2114f8b8433ebd6d013c71.png"
                          alt="MARPPLE"
                        />
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td>${this.data.template}</td>
                  </tr>
                  <tr>
                    <td height="48">
                      <div style="height: 48px"></div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div style="margin-bottom: 24px; padding: 0 24px;">
                        <div
                          style="margin-bottom: 8px; font-size: 12px; font-weight: 500; line-height: 140%; color: #a5a5a5;"
                        >
                          ${html.preventEscape(T('email.template.footer.no_reply'))}
                        </div>
                        <div
                          style="margin-bottom: 8px; font-size: 12px; font-weight: 500; line-height: 140%; color: #a5a5a5;"
                        >
                          ${html.preventEscape(T('email.template.footer.address'))}
                        </div>
                      </div>
                      <div
                        style="padding: 0 24px; font-size: 12px; font-weight: 500; line-height: 140%; color: #a5a5a5;"
                      >
                        Copyright © Marpple Corp. All Rights Reserved.
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td height="32"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td height="40"></td>
      </tr>
    </table>`;
  }
}

export class MarppleShopEmailLayout extends View<EmailLayoutType> {
  override template() {
    return html`<table cellspacing="0" cellpadding="0" border="0" width="100%" bgcolor="#ebf3fe">
      <tr>
        <td height="40"></td>
      </tr>
      <tr>
        <td>
          <div style="max-width: 600px; margin:0 auto;">
            <div>
              <table
                cellspacing="0"
                cellpadding="0"
                width="100%"
                bgcolor="#ffffff"
                style="border-top: 2px solid #1C75FF;"
              >
                <tbody>
                  <tr>
                    <td height="48"></td>
                  </tr>
                  <tr>
                    <td height="24" style="text-align: center">
                      <a style="height: 24px" href="${MCO_DOMAIN.MarppleShop}" target="_blank">
                        <img
                          style="height: 24px"
                          src="https://s3.marpple.co/files/u_2283830/2024/9/original/d6ce5ca81743de3ecd21cb239fdf55fff6e4ca162.png"
                          alt="MARPPLESHOP"
                        />
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td>${this.data.template}</td>
                  </tr>
                  <tr>
                    <td height="48">
                      <div style="height: 48px"></div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div style="margin-bottom: 24px; padding: 0 24px;">
                        <div
                          style="margin-bottom: 8px; font-size: 12px; font-weight: 500; line-height: 140%; color: #a5a5a5;"
                        >
                          ${html.preventEscape(T('email.template.footer.no_reply'))}
                        </div>
                        <div
                          style="margin-bottom: 8px; font-size: 12px; font-weight: 500; line-height: 140%; color: #a5a5a5;"
                        >
                          ${html.preventEscape(T('email.template.footer.address'))}
                        </div>
                      </div>
                      <div
                        style="padding: 0 24px; font-size: 12px; font-weight: 500; line-height: 140%; color: #a5a5a5;"
                      >
                        Copyright © Marpple Corp. All Rights Reserved.
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td height="32"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td height="40"></td>
      </tr>
    </table>`;
  }
}

export class CietyEmailLayout extends View<EmailLayoutType> {
  override template() {
    return html`<table cellspacing="0" cellpadding="0" border="0" width="100%" bgcolor="#13131A">
      <tr>
        <td height="40"></td>
      </tr>
      <tr>
        <td>
          <div style="max-width: 600px; margin:0 auto;">
            <div>
              <table
                cellspacing="0"
                cellpadding="0"
                width="100%"
                bgcolor="#28282F"
                style="border-top: 2px solid #B2FF00;"
              >
                <tbody>
                  <tr>
                    <td height="48"></td>
                  </tr>
                  <tr>
                    <td height="24" style="text-align: center">
                      <a style="height: 24px" href="${MCO_DOMAIN.Ciety}" target="_blank">
                        <img
                          style="height: 24px"
                          src="https://s3.marpple.co/files/u_2283830/2025/3/original/a2ff590241813e8508dd9d758eef19290cc874b01.png"
                          alt="MARPPLESHOP"
                        />
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td>${this.data.template}</td>
                  </tr>
                  <tr>
                    <td height="48">
                      <div style="height: 48px"></div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div style="margin-bottom: 24px; padding: 0 24px;">
                        <div
                          style="margin-bottom: 8px; font-size: 12px; font-weight: 500; line-height: 140%; color: #B1B1B1;"
                        >
                          ${html.preventEscape(T('email.template.footer.no_reply'))}
                        </div>
                        <div
                          style="margin-bottom: 8px; font-size: 12px; font-weight: 500; line-height: 140%; color: #B1B1B1;"
                        >
                          ${html.preventEscape(T('email.template.footer.address'))}
                        </div>
                      </div>
                      <div
                        style="padding: 0 24px; font-size: 12px; font-weight: 500; line-height: 140%; color: #B1B1B1;"
                      >
                        Copyright © Marpple Corp. All Rights Reserved.
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td height="32"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td height="40"></td>
      </tr>
    </table>`;
  }
}

export const EmailCertificationTemplate = {
  ['Marpple']: MarppleEmailCertificationTemplate,
  ['MarppleShop']: MarppleShopEmailCertificationTemplate,
  ['Ciety']: CietyEmailCertificationTemplate,
} as const;

export const EmailCertificationForSignupTemplate = {
  ['Marpple']: MarppleEmailCertificationForSignupTemplate,
  ['MarppleShop']: MarppleShopEmailCertificationForSignupTemplate,
  ['Ciety']: CietyEmailCertificationForSignupTemplate,
} as const;

export const SignupEmailTemplate = {
  ['Marpple']: MarppleSignupEmailTemplate,
  ['MarppleShop']: MarppleShopSignupEmailTemplate,
  ['Ciety']: CietySignupEmailTemplate,
} as const;

export const EmailLayout = {
  ['Marpple']: MarppleEmailLayout,
  ['MarppleShop']: MarppleShopEmailLayout,
  ['Ciety']: CietyEmailLayout,
} as const;

export const createSignupEmailTemplate = ({
  theme,
  props,
}: {
  theme: 'Marpple' | 'MarppleShop' | 'Ciety';
  props: SignupEmailTemplateType;
}) => {
  return new EmailLayout[theme]({ template: new SignupEmailTemplate[theme](props) }).toHtml();
};

export const createEmailCertificationTemplate = ({
  theme,
  props,
}: {
  theme: 'Marpple' | 'MarppleShop' | 'Ciety';
  props: EmailCertificationTemplateType;
}) => {
  return new EmailLayout[theme]({ template: new EmailCertificationTemplate[theme](props) }).toHtml();
};

export const createEmailCertificationForSignupTemplate = ({
  theme,
  props,
}: {
  theme: 'Marpple' | 'MarppleShop' | 'Ciety';
  props: EmailCertificationTemplateType;
}) => {
  return new EmailLayout[theme]({ template: new EmailCertificationForSignupTemplate[theme](props) }).toHtml();
};
